module.exports = __webpack_public_path__ + "static/media/detail_delete.f22b0011.svg";